<template>
    <div class="styleInstance">
        <div class="top disflex">
            <div class="imgBox"><img :src="data.logo" alt="" /></div>
            <div class="cent-box">
                <span>{{ data.name || '专场名称' }}</span
                ><br />
                <div class="disflex solTag">
                    <el-tag
                        v-for="(item, index) in data.tagList"
                        size="mini"
                        :key="index"
                        :style="`border-color:${item.bgColor};color:${item.bgColor}`"
                        class="setTag"
                    >
                        {{ item.name }}
                    </el-tag>
                </div>
            </div>

            <el-button class="butCol" size="mini">{{ data.facade_widget.entry_button.text || '进入专场' }}</el-button>
        </div>

        <div class="items">
            <div class="item">
                <div class="imgPriceBox"></div>
                <div class="price">
                    <span>{{ data.facade_widget.product_price.text || '秒杀价' }}</span>
                    <span class="price-text">￥11.9</span>
                </div>
            </div>
            <div class="item">
                <div class="imgPriceBox"></div>
                <div class="price">
                    <span>{{ data.facade_widget.product_price.text || '秒杀价' }}</span>
                    <span class="price-text">￥11.9</span>
                </div>
            </div>
            <div class="item">
                <div class="imgPriceBox"></div>
                <div class="price">
                    <span>{{ data.facade_widget.product_price.text || '秒杀价' }}</span>
                    <span class="price-text">￥11.9</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    watch: {
        data: {
            handler(data) {
                console.log(data, 'data');
            }
        }
    },
    data() {
        return {
            tagList: []
        };
    }
};
</script>

<style lang="scss" scoped>
.styleInstance {
    border: 1px solid #ccc;
    padding: 10px;
    width: max-content;
    width: 400px;

    .disflex {
        display: flex;
        align-items: center;
    }

    .imgBox {
        width: 44px;
        height: 44px;
        border: 1px solid #ccc;
        border-radius: 10px;
        background: #ccc;
        padding: 5px;
        & > img {
            width: 100%;
            height: 100%;
        }
    }

    .cent-box {
        line-height: 1.4;
        margin: 0 20px;
        flex: 1;
        width: 0;
    }

    .butCol {
        color: #fff;
        background: #db231f;
    }

    .cover {
        width: 100%;
        height: 160px;
        border-radius: 10px;
        margin-top: 10px;
        overflow: hidden;
        & > img {
            width: 100%;
            height: 100%;
        }
    }

    .items {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .item {
            flex: 0 0 32%;
            line-height: 1.4;
            .imgPriceBox {
                width: 100%;
                height: 140px;
                margin-bottom: 10px;
                border-radius: 10px;
                background: #ccc;
            }

            .price {
                font-size: 12px;
                .price-text {
                    color: #db231f;
                    font-size: 16px;
                }
            }
        }
    }

    .setTag {
        color: #fff;
        margin-right: 10px;
    }

    .solTag {
        overflow: hidden;
    }
}
</style>